module.exports = __webpack_public_path__ + "assets/img/elem2-ability1.c0966dcb.gif";